import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {EVENT_CALENDAR_ROUTE, PRIVATE_EVENT_CALENDAR_ROUTE} from "src/app/app-routing.module";
import {AbstractComponent} from "@components";
import {Country, FetchRaceByIdRequest, JwtResponse, Lookups, Money, Race, UserDetail, WspayFormRequest} from "@model";
import {AuthenticationService, RaceService, UserDetailService, WsPayService} from "@services";

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    animations: [
        trigger('fadeInAnimation', [
            state('in', style({ opacity: 1 })),
            transition(':enter', [
                style({ opacity: 0 }),
                animate(1600)
            ])
        ])
    ],
    standalone: false
})
export class PaymentComponent extends AbstractComponent implements OnInit {
  static DEFAULT_COUNTRY: string = "HRVATSKA";
  paymentComponentState: PaymentComponentState = PaymentComponentState.INITIAL;
  paymentComponentStateType = PaymentComponentState;
  currentRace: Race | null = null;
  competitorId?: number;
  currentUserDetails: UserDetail | undefined;
  isLoggedIn: boolean = false;
  @Input() countries: Country[] = [];

  constructor(private wsPayService: WsPayService, private raceService: RaceService, private route: ActivatedRoute, private router: Router,
              private authenticationService: AuthenticationService, private userDetailService: UserDetailService) {
    super();
  }

  ngOnInit(): void {
    let raceId: number = +this.route.snapshot.queryParams['raceId'];
    this.competitorId = +this.route.snapshot.queryParams['competitorId'];
    if (this.raceService.currentRace.value?.id !== raceId) {
      this.raceService.findRace(new FetchRaceByIdRequest(raceId), () => {
      }, () => {
      });
    }
    this.subscriptions.push(this.raceService.currentRace.subscribe((value: Race | undefined) => {
      if (value) {
        this.currentRace = value;
      }
    }));
    this.subscriptions.push(this.authenticationService.jwtResponse.subscribe((jwtResponse: JwtResponse | null) => {
      this.isLoggedIn = !!jwtResponse?.token;
      if (this.isLoggedIn) {
        this.fetchUserProfile();
      } else {
        this.subscriptions.push(this.raceService.registerToRaceUserData.subscribe((value: UserDetail | null) => {
          if (value) {
            this.currentUserDetails = value;
          }
        }));
      }
    }));
  }

  private fetchUserProfile(): void {
    this.subscriptions.push(this.userDetailService.currentUserDetails.subscribe((userDetails: UserDetail | undefined) => {
      this.currentUserDetails = userDetails;
      if (this.currentUserDetails) {
        this.currentUserDetails!.birthDay = new Date();
      }
    }));
  }

  onPay(): void {
    this.wsPayService.fetchWsPayForm(new WspayFormRequest(this.currentUserDetails?.firstname, this.currentUserDetails?.lastname, this.currentUserDetails?.address,
      this.currentUserDetails?.city, this.currentUserDetails?.zip ?? "10000", this.getCountryString(this.currentUserDetails?.country!), this.currentUserDetails?.phoneNumber, this.currentUserDetails?.email,
      new Money(100, "EUR"), this.currentRace?.id, this.competitorId), (redirectUrl) => {
      this.goToWsPay(redirectUrl);
    }, () => {

    });
  }

  getCountryString(countryCode: number): string {
    if (!!countryCode) {
      return PaymentComponent.DEFAULT_COUNTRY;
    }
    let country: Country | undefined = this.countries.find((country: Country) => {
      return country.id === countryCode;
    });
    return country?.name?.toUpperCase() ?? PaymentComponent.DEFAULT_COUNTRY;
  }


  goToWsPay(redirectUrl: string): void {
    window.location.href = redirectUrl;
  }

  toHome(): void {
    this.router.navigate([this.isLoggedIn ? PRIVATE_EVENT_CALENDAR_ROUTE : EVENT_CALENDAR_ROUTE]);
  }
}

enum PaymentComponentState {
  INITIAL,
  ERROR
}
